const getEnv = (key) => process.env[key];

export const config = {
  baseUrl: getEnv("REACT_APP_API_BASE_URL"),
  recaptchaSiteKey: getEnv("REACT_APP_SITE_KEY_ONLINE"),
  getPublicImages: getEnv("REACT_APP_PUBLIC"),
};